import { orgAPI } from "@/api/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type UpdateCommand =
  | { command: "update_properties"; properties: Record<string, any> }
  | { command: "replace_content"; new_str: string }
  | {
      command: "replace_content_range";
      selection_with_ellipsis: string;
      new_str: string;
    }
  | {
      command: "insert_content_after";
      selection_with_ellipsis: string;
      new_str: string;
    };

interface UpdateNotionPageParams {
  connectionId: string;
  pageId: string;
  data: UpdateCommand;
}

export function useNotionPageUpdate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      connectionId,
      pageId,
      data,
    }: UpdateNotionPageParams) => {
      return orgAPI.toolbox.execute({
        integration_connection_id: connectionId,
        action_name: "notion-mcp-update-page",
        action_input: { data: { page_id: pageId, ...data } },
      });
    },
    onSuccess: (_, { connectionId, pageId }) => {
      queryClient.invalidateQueries({
        queryKey: ["notion-page", connectionId, pageId],
      });
    },
  });
}
